import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { bindPromiseCreators } from 'redux-saga-routines';
import { reduxForm, Field, Form, submit } from 'redux-form/immutable';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';
import FileUpload from '@material-ui/icons/CloudUpload';
import ActionPrint from '@material-ui/icons/Print';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import _ from 'lodash';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import Grid from '@material-ui/core/Grid';

import TasksGrid from '../../Tasks/TasksGrid/index';
import { showDialog, hideDialog } from '../../../redux/actions/dialogs';
import TaskDialog from '../../Tasks/TaskDialog/index';
import {
  saveJobFormHandler,
  fetchTasksRoutine,
  fetchEmployeesPromise,
  fetchJobRoutine, fetchEmployeesRoutine
} from '../../../redux/routines';
import TaskPhotosDialog from '../../Tasks/TaskPhotosDialog/index';
import { toJS } from '../../../utils/helper';
import { hasPermission } from '../../../utils/authenticated';
import ReduxDialog from '../../Common/ReduxDialog/index';

import StagesTable from '../../StagesGrid/index';
import {
  renderResources,
  renderSelect,
  renderTags,
  renderTextField,
  renderMuiDatePicker
} from '../../../utils/reduxforms';
import { getDialogContextValue, isDialogVisibleSelector } from '../../../redux/selectors';
import {
  CONFIRM_DIALOG,
  GENERATE_LABELS_DIALOG, JOB_DIALOG,
  TASK_DIALOG,
  TASK_PHOTOS_DIALOG,
  TASK_UPLOAD_DIALOG
} from '../../../redux/constants/dialogs';

import styles from './styles';
import { uuid } from 'short-uuid';

class JobDialog extends Component {
  state = {
    selectedTasks: [],
    tab: 0,
  };

  componentWillMount() {
    const id = this.props.initialValues.get('id');
    if (id) {
      this.props.fetchTasks(id, { limit: 10 });
    }

    this.setState({
      editable: hasPermission(['Administrator', 'JobCreator']),
    });

    this.props.fetchEmployees({ limit: 100 });
  }

  handleOriginChange = (a, b, c) => {
    console.log('handleOriginChange', a, b, c);
  };

  handleUpload = () => {
    this.props.showDialog(TASK_UPLOAD_DIALOG, { job: this.props.initialValues.toJS() });
  };

  handleAddResources = (spec) => {
    console.log('handleAddResource', spec);
    const resources = _.range(spec.quantity).map(() => _.assign(_.omit(spec, ['quantity']), { id: uuid() }));
    this.props.addResources(this.props.job, resources);
    this.setState({
      resource: 'added',
    });
  };

  handleResetResources = (state) => {
    // console.log('state', state);
    return state;
  };

  handleGenerateLabels = () => {
    const { initialValues } = this.props;
    const job = initialValues.toJS();

    if (job && job.tasks && job.tasks.count) {
      this.props.showDialog(GENERATE_LABELS_DIALOG, {
        job,
        tasks: this.state.selectedTasks.length > 0 ? this.state.selectedTasks : null,
      });
    } else {
      this.props.showError('Error', 'This job does not currently have any tasks');
    }
  };

  handleTaskProfilesChanged = (taskProfiles) => {
    console.log('handleTaskProfilesChanged', taskProfiles);
  };

  handleEditResource = (resource) => {
    console.log('handleEditResource', resource);
    this.props.setResourceEmployee(this.props.job, resource, resource.employee);
  };

  handleRemoveResource = (resource) => {
    console.log('handleRemoveResource', resource);
    this.props.removeResource(this.props.job, resource);
  };

  handleEditTask = (job, task) => {
    console.log('handleEditTask', task);
    this.props.showDialog(TASK_DIALOG, { job, task });
  };

  handleRemoveTask = (task) => {
    const context = {
      type: 'warning',
      title: 'Remove Task?',
      message: 'Are you sure you wish to remove this task?',
      buttons: [
        <Button
          variant="text"
          onClick={() => this.props.hideDialog(CONFIRM_DIALOG)}
        >Cancel</Button>,
        <Button
          variant="text"
          onClick={() => {
            this.props.hideDialog(CONFIRM_DIALOG);
            this.props.removeTask(task);
          }}
        >Remove</Button>,
      ],
    };

    this.props.showDialog(CONFIRM_DIALOG, context);
  };

  handleDiscard = () => {
    this.props.hideDialog(JOB_DIALOG);
  };

  handleTaskSelection = (selectedIdxs, selectedTasks) => {
    console.log('selectedIdxs', selectedIdxs);
    console.log('selectedTasks', selectedTasks);

    this.setState({
      selectedTasks,
    });
  };

  renderOverview(job, editable) {
    const addresses = toJS(this.props.initialValues.getIn(['customer', 'addresses'])) || [];

    return (<div style={styles.overview}>
      <Grid container spacing={8}>
        <Grid item xs={6}>
          <Field
            name="reference"
            component={renderTextField}
            label="Reference"
            fullWidth
            readOnly={!editable}
          />
        </Grid>
        <Grid item xs={6}>
          <Field
            name="customer.name"
            component={renderTextField}
            label="Customer"
            fullWidth
            readOnly
          />
        </Grid>
        <Grid item xs={6}>
          <Field
            name="origin.id"
            component={renderSelect}
            label="Origin"
            fullWidth
            readOnly={!editable}
          >
            {addresses.map((address) => {
              return (<MenuItem key={address.id} value={address.id}>{address.line1}</MenuItem>);
            })}
          </Field>
        </Grid>
        <Grid item xs={6}>
          <Field
            name="destination.id"
            component={renderSelect}
            label="Destination"
            fullWidth
            readOnly={!editable}
          >
            {addresses.map((address) => {
              return (<MenuItem key={address.id} value={address.id}>{address.line1}</MenuItem>);
            })}
          </Field>
        </Grid>
        <Grid item xs={6}>
          <Field
            name="start"
            component={renderMuiDatePicker}
            label="Start"
            fullWidth
            autoOk
            disabled={!editable}
          />
        </Grid>
        <Grid item xs={6}>
          <Field
            name="end"
            component={renderMuiDatePicker}
            label="End"
            fullWidth
            autoOk
            disabled={!editable}
          />
        </Grid>
        <Grid item xs={12}>
          <Field
            name="description"
            component={renderTextField}
            label="Description"
            fullWidth
            multiline
            rows={3}
            readOnly={!editable}
          />
        </Grid>

        <Grid item xs={12}>
          <Field
            label="Tags"
            name="tags"
            component={renderTags}
          />
        </Grid>

        <Grid item xs={12}>
          <Field
            name="notes"
            component={renderTextField}
            label="Notes"
            fullWidth
            multiline
            rows={3}
            readOnly={!editable}
          />
        </Grid>
      </Grid>
    </div>);
  }

  render() {
    const { handleSubmit, initialValues, tasks, isDialogVisible, showDialog, employees, submit } = this.props;
    const job = initialValues.toJS();
    const { editable, tab } = this.state;

    const buttons = [
      <Button
        variant="text"
        key="cancel"
        onClick={this.handleDiscard}
      >{editable ? 'Cancel' : 'Close'}</Button>,
    ];

    if (editable) {
      buttons.push(<Button
        variant="contained"
        key="save"
        color="primary"
        type="submit"
        onClick={submit}
      >Save</Button>);
    }

    // console.log('job', job);

    return (
      <ReduxDialog
        name={JOB_DIALOG}
        title={job && job.customer ? job.customer.name : 'Create Job...'}
        subTitle={job.description || ''}
        rightToolbar2={<div>
          <Tooltip title="Upload Tasks">
            <IconButton onClick={this.handleUpload}><FileUpload color="inherit"/></IconButton>
          </Tooltip>
          <Badge
            badgeContent={this.state.selectedTasks.length || _.keys(this.props.tasks).length}
            color="secondary"
          >
            <IconButton
              tooltip="Generate Labels"
              onClick={this.handleGenerateLabels}>
              <ActionPrint color="inherit"/>
            </IconButton>
          </Badge>
        </div>}
        actions={buttons}
        fullWidth
        maxWidth="md"
      >
        <Form name="Job" onSubmit={handleSubmit(saveJobFormHandler)} style={styles.form}>
          <AppBar position="static">
            <Tabs value={tab} onChange={(evt, tab) => this.setState({ tab })}>
              <Tab label="Overview" value={0}/>
              <Tab label="Resources" value={1}/>
              <Tab label="Stages" value={2}/>
              <Tab label={`Tasks (${job.tasks && job.tasks.count ? job.tasks.count : 0})`} value={3}/>
            </Tabs>
          </AppBar>
          {tab === 0 ? this.renderOverview(job, editable) : null}
          {tab === 1 ? <div style={styles.tabPage}>
            <Field
              name="resources"
              component={renderResources}
              employees={employees}
              editable={editable}
            />
          </div> : null}
          {tab === 2 ? <div style={styles.tabPage}>
            <StagesTable stages={job.profile ? job.profile.stages || [] : []}/>
          </div> : null}
          {tab === 3 ? <div style={styles.tabPage}>
            <TasksGrid
              job={job}
              data={tasks}
              onEdit={editable ? (task) => this.handleEditTask(job, task) : null}
              onRemove={editable ? this.handleRemoveTask : null}
              onViewImages={(task) => showDialog(TASK_PHOTOS_DIALOG, { job, task })}
              onRowSelection={this.handleTaskSelection}
              showDialog={showDialog}
            />
          </div> : null}

        </Form>

        {isDialogVisible(TASK_DIALOG) ? <TaskDialog/> : null}
        {isDialogVisible(TASK_PHOTOS_DIALOG) ? <TaskPhotosDialog/> : null}
      </ReduxDialog>
    );
  }
}

JobDialog.propTypes = {
  fetchTasks: PropTypes.func.isRequired,
  fetchEmployees: PropTypes.func.isRequired,
  employees: PropTypes.array,

  tasks: PropTypes.object,

  onDiscard: PropTypes.func,
  onSave: PropTypes.func,
};

const form = reduxForm({
  form: JOB_DIALOG,  // a unique identifier for this form
  onSubmit: (values, dispatch, props) => {
    console.log('onSubmit', values, dispatch, props);
    //   const job = values
    //     // .set('profile', fromJS(props.job.profile || {}))
    //     // .set('taskProfiles', fromJS(props.job.taskProfiles || []))
    //     // .set('resources', fromJS(props.job.resources || {}))
    //     // .set('preferredItems', fromJS(props.job.preferredItems || {}))
    //     // .set('tasks', fromJS(props.job.tasks || { count: 0 }));
    //   return dispatch(saveJobRoutine.trigger({ values: job }));
  },
  onSubmitSuccess: (result, dispatch, props) => {
    props.hideDialog(JOB_DIALOG);
  },
})(JobDialog);

function mapStateToProps(state) {
  return {
    tasks: toJS(state.getIn(['tasks', 'tasks'])),
    employees: toJS(state.getIn(['employees', 'employees', 'data'])),
    initialValues: getDialogContextValue(state)(JOB_DIALOG, 'job'),
    isDialogVisible: isDialogVisibleSelector(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      fetchJob: fetchJobRoutine.trigger,
      fetchTasks: (jobId, query) => fetchTasksRoutine.trigger({ jobId, query }),
      fetchEmployees: fetchEmployeesRoutine.trigger,
      showDialog,
      hideDialog,
    }, dispatch),
    ...bindPromiseCreators({
      // fetchEmployees: fetchEmployeesPromise,
    }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/Jobs/JobDialog/index.js